<template>
  <div class="art-item art-item4">
    <common-top :commonTopData="commonTopData"></common-top>
    <comTable
      @selectedDatafn="selectedDatafn"
      :config="tableConfig"
      :filterForm="filterForm"
      ref="table"
    >
      <template v-slot:leftBten>
        <el-button
          class="feature-item add"
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addFn()"
          >新建文章</el-button
        >
      </template>
    </comTable>

    <el-dialog :title="dgtitle" :visible.sync="dialogTableVisible">
      <span class="bo_009_2">选择展示渠道</span>
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
      <span class="bo_009_3">|</span>
      <el-checkbox-group
        class="bo_009_1"
        v-model="channel"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox v-for="el in channels" :label="el.value" :key="el.value">{{
          el.label
        }}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="checkPus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTop from "@/components/commonTop.vue";
// import comTable from "@/components/comTable.vue";
import comTable from "@/components/firTable.vue";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    commonTop,
    comTable,
  },
  data() {
    // 这里存放数据
    return {
      channel: [],
      channels: [],
      plAjax: false,
      checkAll: false,
      isIndeterminate: true,
      dgtitle: "文章批量渠道设置",
      dialogTableVisible: false,
      ajaxType: false,
      ajaxType2: false,
      tableConfig: {
        url: "getArticleList",
        list: [
          { label: "文章ID", prop: "id" },
          { label: "文章封面图", prop: "prev_url", type: "img" },
          { label: "文章标题", prop: "title" },
          { label: "IP名称", prop: "title" ,type: "html",
            clfn:row=>{
              let pn = this.ipList.find(e=>{return e.ip_id==row.ip_id})
            return pn?pn.ip_name:"";
          }},
          { label: "创作者昵称", prop: "author" ,width:90},
          
          {
            label: "文章分类",
            prop: "classify",
            type: "html",
            clfn: (da) => {
              let classify = [];
              try {
                classify = JSON.parse(da.classify);
              } catch (error) {
                console.log(error);
              }
              return classify.join("/");
            },
          },
          {
            label: "标签",
            prop: "tags",
            type: "html",
            clfn: (da) => {
              let arr = [];
              if(!da.tags){
                return ''
              }
              try {
                arr = JSON.parse(da.tags);
              } catch (error) {
                console.log(error);
              }
              let str = "";
              arr.map((e) => {
                str += `<span class="tages">${e}</span>`;
              });
              return str;
            },
          },
          { label: "创建人", prop: "creator" },
          { label: "创建时间", prop: "create_at" },
          {
            label: "状态",
            prop: "status",
            type: "html",
            clfn: (da) => {
              let str = "";
              str += `<span class="colors${da.status}">${
                da.status == 0 ? "待上架" : da.status == 1 ? "上架" : "下架"
              }</span>`;
              return str;
            },
          },
          {
            label: "可展示渠道",
            prop: "allow_channel",
            type: "html",
            width: 230,
            clfn: (da) => {
              let arr = [];
              try {
                arr = da.allow_channel.split(",");
              } catch (error) {
                console.log(error);
              }
              let str = "";
              arr.map((e) => {
                this.channels.map((e2) => {
                  if (e == e2.value) {
                    str += `<span class="txt">${e2.label}</span>`;
                  }
                });
              });

              return str;
            },
          },
          {
            label: "操作",
            type: "tool",
            btns: [
              {
                label: "查看",
                clickFn: (da) => {
                  this.handleBtn(da, "look");
                },
              },
              {
                label: "编辑",
                clickFn: (da) => {
                  this.handleBtn(da, "edit");
                },
              },
              {
                label: "删除",
                clickFn: (da) => {
                  this.handleDel(da);
                },
              },
              {label:'',prop: 'status', backLabel:da=> {
                return da.status == 0 ? '上架': da.status == 1 ? '下架': '上架'
              },clickFn:da=>{
                this.shelveSwitch(da)
              }}
            ],
          },
        ],
        isSelection: false,
        showAllBtn: false,
        allBtn: [
          {
            label: "取消操作",
            clickFn: () => {
              this.tableConfig.isSelection = false;
              this.tableConfig.showAllBtn = false;
            },
          },
          {
            label: "渠道修改",
            clickFn: () => {
              if (this.plAjax) {
                this.$message("正在处理请稍后");
                return;
              }
              let len = this.checKData.length;
              if (len == 0) {
                this.$message("请选择要修改的数据");
                return;
              }
              if (len == 1) {
                this.dgtitle = `文章渠道设置 ${this.checKData[0].title}`;
              } else {
                this.dgtitle = `文章批量渠道设置 已选${len}篇文章`;
              }

              this.getChannels();
              this.dialogTableVisible = true;
            },
          },
          {
            label: "删除",
            clickFn: () => {
              this.handleDelx(this.checKData);
            },
          },
        ],
      },
      checKData: [],
      drawer: false,
      direction: "rtl",
      item: "",
      form: {
        id: "",
        title: "",
        classify: "",
        tags: "",
        creator: "",
      },
      category: [], // 文章分类
      


      filterForm: [
        { prop: "id", label: "文章ID", pl: "请输入文章ID检索", type: "text" },
        {
          prop: "title",
          label: "文章标题",
          pl: "请输入文章标题检索",
          type: "text",
        },
        {
          prop: "classify",
          label: "文章分类",
          pl: "请选择文章分类",
          type: "cascader",
          vlabel: "classify_name",
          vvalue: "classify_name",
          children: "child",
          option: [],
        },
        { prop: "tags", label: "标签", pl: "请输入标签检索", type: "text" },
        {
          prop: "creator",
          label: "创建人",
          pl: "请输入创建人检索",
          type: "text",
        },
        {
          prop: "ip_id",
          label: "IP名称",
          pl: "请选择IP名称",
          type: "select",
          vlabel: "ip_name",
          vvalue: "ip_id",
          child: [],

        },
        {
          prop: "author",
          label: "创作者昵称",
          pl: "请输入创作者昵称",
          type: "text",
        },
      ],
      timer: null,
      commonTopData: {
        commonleftbtn: [],
      },
      list1: [],
      allche: [],
      ipList:[]
    };
  },
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getArticleClassify();
    this.getChannels();
    this.getIpList()
  },
  // 方法集合
  methods: {
    getIpList() {
      this.api.getIpList().then((res) => {
        if (!res) return;
        let { data } = res;
        this.ipList = data;

        this.filterForm[5].child = data.map((val)=>{
          return {
            ...val,
            name:val.ip_name,
            id:val.ip_id
          }
        })
      });
    },

    checkPus() {
      let pd = false;

      this.allche.map((e) => {
        if (this.channel.indexOf(e) == -1) {
          pd = true;
        }
      });

      if (!pd) {
        this.pushFn();
        return;
      }
      this.$confirm(
        `取消渠道后，文章将不会在该渠道文章库内展示<br/>但文章关联的内容仍可能在渠道展示位中，请及时删除专题列表配置`,
        "文章渠道设置提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        this.pushFn();
      });
    },
    pushFn() {
      this.plAjax = true;
      this.api
        .quickerSetArticleChannel({
          id: this.checKData
            .map((e) => {
              return e.id;
            })
            .join(","),
          channel: this.channel.join(","),
        })
        .then((da) => {
          this.plAjax = false;
          if (da == "error") {
            return;
          }
          this.$message("修改成功");
          this.dialogTableVisible = false;
          this.$refs.table.getData();
        })
        .catch(() => {
          this.plAjax = false;
        });
    },
    getChannels() {
      this.api.channels().then((res) => {
        this.channels = res.data.map((item) => {
          return {
            label: item.channel_name,
            value: item.channel,
          };
        });
        let arr = [];
        this.checKData.map((e) => {
          let ps = e.allow_channel.split(",");
          ps.map((e2) => {
            if (arr.indexOf(e2) == -1) {
              arr.push(e2);
            }
          });
        });

        this.channel = arr;
        this.allche = [];
        this.allche = this.allche.concat(arr);
      });
    },
    handleCheckAllChange(val) {
      let odm = this.channels.map((e) => {
        return e.value;
      });
      this.channel = val ? odm : [];

      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.channels.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.channels.length;
    },
    selectedDatafn(da) {
      this.checKData = da;
    },
    getData(data) {
      this.$refs.table.getData(data);
    },
    addFn() {
      this.$router.push(`/art/item4-addArticle?type=add`);
    },
    // 查看/编辑
    handleBtn(row, type) {
      let routeUrl = this.$router.resolve({
          path: "/art/item4-addArticle",
          query: {id:row.id,type:type}
     });
     window.open(routeUrl.href, '_blank');
    },
    handleClose(done) {
      done();
    },
    // 删除
    handleDel(row) {
      this.handleDelx([row]);
    },
    handleDelx(da) {
      if (this.ajaxType) {
        this.$message("正在处理请稍后");
        return;
      }
      let len = da.length;
      let nam = "";
      if (len < 1) {
        this.$message("请选择要删除的内容");
        return;
      }
      if (len == 1) {
        nam = `文章删除 ${da[0].title}`;
      } else {
        nam = `文章批量删除 已选${len}条内容`;
      }

      this.$confirm(
        `是否将选中文章删除？<br/>文章删除后，展示位内的 <span style="">专题列表-内容</span>与<span>内容</span>本身将同步删除`,
        nam,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
     
        let ids = da.map(e=>{
          return e.id
        })
       
        this.delArticle({
          id: ids.join(","),
        });
      });
    }, 
    delArticle(data) {
      this.ajaxType = true;
      this.api
        .delArticle(data)
        .then((res) => {
          this.ajaxType = false;
          if (!res) return;
          this.$message.success("删除成功");
          this.$refs.table.getData();
        })
        .catch(() => {
          this.ajaxType = false;
        });
    },
    // 获取文章分类
    getArticleClassify() {
      this.api.getArticleClassify().then((res) => {
        if (!res) return;
        let { data } = res;
        this.filterForm[2].option = data;
        console.log(this.filterForm[2])
      });
    },
    // 上下架确认
    shelveSwitch(row) {
      this.$confirm(
        `确定要${
          row.status == 1 ? "下" : "上"
        }架标题为<span style="color:red">${row.title}</span> 的文章吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        let data = {
          id: row.id,
          status: row.status == 0 ? 1 : row.status == 1 ? -1 : 1,
        };
        this.shelveArticle(data);
      });
    },
    shelveArticle(data) {
      this.api.shelveArticle(data).then((res) => {
        if (!res) return;
        this.$message.success("操作成功");
        this.getData();
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    confirmFn() {
      this.drawer = false;
      let data = {
        id: this.form.id,
        title: this.form.title,
        tags: this.form.tags,
        creator: this.form.creator,
      };
      if (this.form.classify.length > 0 && this.form.classify[0]) {
        data.classify = JSON.stringify(this.form.classify);
      }
      this.$refs.table.getData(data);
    },
    filterBtn() {
      this.drawer = true;
      this.$refs.table.handleCurrentChange(1);
    },
  },
};
</script>
<style >
</style>
<style lang='scss' scoped>
.art-item4 {
  height: 100%;
  .container {
    height: calc(100% - 80px);
    position: relative;
    .feature {
      position: relative;
      height: 50px;
      .feature-item {
        position: absolute;
        z-index: 9;
      }
      .add {
        top: 0;
        left: 10px;
      }
      .filter {
        top: 10px;
        right: 10px;
        color: #999;
        cursor: pointer;
        img {
          margin-right: 3px;
        }
      }
    }
  }
}
</style>

<style lang='scss'>
.art-item4 {
  .tableboxs {
    .colors0 {
      color: #d1d1d1;
    }
    .colors1 {
      color: #2dc72d;
    }
    .colors-1 {
      color: red;
    }
  }
  .txt {
    display: inline-block;
    vertical-align: top;
    margin-right: 15px;
  }
}
.bo_009_1 {
  display: inline-block;
  vertical-align: top;
}
.bo_009_2 {
  margin-right: 30px;
}
.bo_009_3 {
  margin: 0 10px;
}
</style>
